import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { getAccessorials } from "@tKgpco/Services/AccessorialsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { AccessorialState } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, AccessorialState>;

export const BeginLoadAccessorials: HandlerType = props => {
    props.dispatch({ type: "Custom/Accessorials/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getAccessorials();
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteLoadAccessorials: HandlerType = props => {
    props.dispatch({
        type: "Custom/Accessorials/CompleteLoad",
        accessorials: props.apiResult,
    });
};

export const chain = [BeginLoadAccessorials, RequestDataFromApi, CompleteLoadAccessorials];

const loadAllAccessorials = createHandlerChainRunnerOptionalParameter(chain, {}, "CustomLoadAccessorials");
export default loadAllAccessorials;
